import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { HAS_DETAIL_VIEW_ONE_PERMISSION_OF, PERMISSIONS } from '@/constants/permissions.ts'

const routeCompanyHome: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/settings/company/ViewCompany.vue')
  },
  meta: {
    detail: { doctype: DOCTYPES.COMPANY, perm_type: PERMISSIONS.READ },
    doctypes: { [DOCTYPES.COMPANY]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF },
  },
  name: 'company-detail',
  path: ':id',
}

const routeCompanyRoot: RouteRecordRaw = {
  children: [routeCompanyHome],
  path: 'company',
}

export { routeCompanyHome, routeCompanyRoot }
